import React from "react";
import Select from "react-select";

const FontSelect = ({ fonts, selectedFont, onFontChange, disabled }) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontFamily: state.data.font,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      fontFamily: state.data.font,
    }),
  };

  const options = fonts.map((font) => ({
    value: font,
    label: font,
    font: font,
  }));

  return (
    <Select
      value={options.find((option) => option.value === selectedFont)}
      onChange={(selectedOption) => onFontChange(selectedOption.value)}
      options={options}
      styles={customStyles}
      isDisabled={disabled}
      className="font-select"
      placeholder="Font"
    />
  );
};

export default FontSelect;
